import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Form } from 'formsy-react' //eslint-disable-line
import {
  Button,
  Colors,
  DatePicker,
} from 'advenio-components'
import ActivityTableCell from '../../Components/ActivityTableCell'
import { ADD_ACTIVITY } from '../../Constants'
import ImageViewer from '../ParentPlatform/ImageViewer'
import EditCheckoutModal from '../../Components/ProfileViews/EditCheckoutModal'
import { userHasRole } from '../../utils/Utils'
import ActivityActions from '../../Data/Redux/ActivityRedux'
import LoadingSpinner from '../../Components/LoadingSpinner'


const TableHeaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  width: 100%;
  background-color: ${Colors.gray300};
  color: white;
`
const AddActivityContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 33%;
  padding: 45px 0;
  float:right;
  margin: -12px 0px;
  @media (max-width:767px) {
    display: none;
  }
`
const ViewMoreContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 16px 0;
`
const AddActivityButton = styled(Button)`
  height: 42px;
  margin-right: 16px;
  padding: 10px 16px;
  font-size: 12px;

  @media (max-width:1200px) {
    height: 32px;
    width: 120px;
    margin-right: 8px;
    padding: 4px 8px;
    font-size: 12px;
  }
`
const AddCheckInButton = styled(Button)`
  flex: 1;
  height: 42px;
  margin-right: 16px;
  margin-left: 16px;
  padding: 10px 16px;
  font-size: 12px;

  @media (max-width:1200px) {
    height: 32px;
    width: 120px;
    margin: 8px;
    padding: 4px 8px;
    font-size: 12px;
  }
`
const AddCheckInContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;

  div{
    width: 100%;
    justify-content: center;
    align-items: center;
    display: flex;
  }

  @media (min-width: 768px) {
    margin: 8px;
    justify-content: flex-end;

    div {
      display: flex;
      justify-content: center;
      width: 300px;
    }
  }
`
const EmptyState = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  opacity: .4;
`
const InputRow = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  flex: 1 1;
  @media (min-width: 768px) {
    flex-wrap: nowrap;
  }
`
const InputContainer = styled.div`
  margin: 0 8px;
  flex: 1;
  ${({ datePicker }) => datePicker && `
    flex: 2;
    margin: 0 0 0px 8px;
  `}
`
const FormActivityContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 0px 0;
  width: 67%;
  float:left;
  @media (max-width:767px) {
    display: none;
  }
`
const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  padding: 16px;
  width: 100%;
  margin: -12px 40px;
`

class RecentActivity extends Component {
  state = {
    image: null,
    isImageViewerOpen: false,
    activities: [],
    start_date: moment().subtract(1, 'months').format('YYYY-MM-DD'),
    end_date: moment().format('YYYY-MM-DD'),
    editCheckoutModal:false,
    checkout_id:null,
  }

  componentWillMount() {
    this.setActivities(this.props.history)
  }

  componentWillReceiveProps(nextProps) {
    this.setActivities(nextProps.history)
  }

  setActivities = (recentActivities) => {
    const activities = Object.keys(recentActivities)
      .filter(date => date !== '0')
      .map(date => ({
        date,
        activities: recentActivities[date],
      }))

    this.setState({ activities })
  }

  deleteActivity = activityId => this.props.onDeleteActivity(activityId)

  handleOpenViewer = image =>
    this.setState({
      image,
      isImageViewerOpen: true,
    })

  closeViewer = () => this.setState({ isImageViewerOpen: false })

  onEditCheckout = checkout_time =>{
   const {checkout_id} =this.state
   this.props.editcheckout(checkout_id,checkout_time)
  }
  editCheckout= (checkout_id ) =>  this.setState({ editCheckoutModal: true, checkout_id })

  handleCloseEditCheckout = () =>  this.setState({ editCheckoutModal: false })
  
  userHasRole = roles => userHasRole(this.props.user.role, roles)
  
  download = () => {
    const{start_date,end_date} = this.state;
    const student_id = this.props.activeStudentId;
    // console.log(start_date+' '+end_date+' '+activeStudentId);
    this.props.getActivityExcel(start_date, end_date,student_id)
  }
  onChange = (model) => {
    this.setState({ start_date: model.start_date, end_date: model.end_date })
  }
  renderRecentActivitiesTable = () => {
    const { activities } = this.state

    if (activities.length <= 0) {
      return (
        <div>
          <TableHeaderContainer>
            <span>{moment().format('DD MMMM YYYY')}</span>
          </TableHeaderContainer>
          <EmptyState>
            No hay actividad reciente
          </EmptyState>
        </div>
      )
    }

    return activities.map(day => (
      <div key={day.date}>
        <TableHeaderContainer>
          <span>{moment(day.date).format('DD MMMM YYYY')}</span>
        </TableHeaderContainer>
        {day.activities.map((activity, index) => (
          <ActivityTableCell
            key={`${activity.id}-${activity.type}-${moment(activity.date).unix()}`}
            index={index}
            registered_by={activity.registered_by}
            onDeleteActivity={this.deleteActivity}
            onEditCheckout={this.editCheckout}
            onPhotoClick={this.handleOpenViewer}
            alone={index === 0 && day.activities.length === 1}
            bottom={index === (day.activities.length - 1)}
            top={index === 0}
            parent={this.props.parent}
            user={this.props.user}
            {...activity}
          />
        ))}
      </div>
    ))
  }

  render() {
    const {
      isDisenrolled,
      onCheckIn,
      onHealthCheck,
      onNewActivityClick,
      student,
      editingcheckout,
      anyLoading,
    } = this.props
    const {
      isImageViewerOpen,
      image,
      editCheckoutModal,
    } = this.state

    return (
      (! anyLoading ?
      <div>
        
        {!this.userHasRole(['Parent', 'Teacher']) && ( 
          <div>
            <FormActivityContainer>
              <Form
              style={{width: '100%'}}
              onChange={this.onChange}
              >
                <Container >
                  <DatePicker
                    name="start_date"
                    label="Fecha Inicio"
                    style={{ marginRight: '5px' }}
                    value={moment().subtract(1, 'months').format('YYYY-MM-DD')}
                    disableAfterToday
                  />
                  <DatePicker
                    name="end_date"
                    label="Fecha Fin"
                    value={moment().format('YYYY-MM-DD')}
                    disableAfterToday
                  />
                  <Button marginRight="0" marginLeft="0" danger small onClick={this.download}>
                    Descargar
                  </Button>
                </Container>
              </Form>
            </FormActivityContainer>
            { !(student && student.checkin.id) &&(
              <AddActivityContainer>
                <AddActivityButton
                  primary
                  small
                  onClick={(student && student.checkin.id) ? onNewActivityClick : onHealthCheck}
                  disabled={Boolean(isDisenrolled||student.checkin.id)}
                >
                  {(student && student.checkin.id) ? ADD_ACTIVITY : 'Check In'}
                </AddActivityButton>
              </AddActivityContainer>)
            }
          </div>
        )}
        {this.userHasRole('Parent') && (
          <AddCheckInContainer>
            <div>
              <AddCheckInButton
                ghost
                fullWidth
                onClick={onCheckIn}
                disabled={Boolean(isDisenrolled)}
              >
                Agregar formato de entrada
              </AddCheckInButton>
            </div>
          </AddCheckInContainer>
        )}
        {this.renderRecentActivitiesTable()}
        <ImageViewer open={isImageViewerOpen} img={image} onClose={this.closeViewer} />
          <EditCheckoutModal
            open={editCheckoutModal}
            onClose={this.handleCloseEditCheckout}
            onEditCheckout={this.onEditCheckout}
            loading={editingcheckout}
          />
         
      </div> 
      : <LoadingSpinner size={50} />)
    )
  }
}

RecentActivity.propTypes = {
  /** The listing of latest activities for the current student */
  history: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
  ]).isRequired,
  /** Indicates whether the current student is disenrolled or not */
  isDisenrolled: PropTypes.bool,
  /** Indicates if the authenticated user is a parent user */
  parent: PropTypes.bool,
  /** The current student */
  student: PropTypes.object.isRequired,
  /** Indicates editing */
  editingcheckout: PropTypes.bool,
  /** Callback function to be fired after checking in the student */
  onCheckIn: PropTypes.func.isRequired,
  /** Callback function to be fired after deleting an activity */
  onDeleteActivity: PropTypes.func.isRequired,
  /** Callback function to be fired after clicking the Check In button */
  onHealthCheck: PropTypes.func.isRequired,
  /** Callback function to be fired after clicking the Register Activity button */
  onNewActivityClick: PropTypes.func.isRequired,
}

RecentActivity.defaultProps = {
  isDisenrolled: false,
  parent: false,
}

const mapStateToProps = state => ({
  anyLoading: state.classrooms.get.fetching,
  user: state.auth.user,
  activeStudentId: state.classrooms.activeStudentId,
  editingcheckout: state.activity.sending.fetching,
})

const mapDispatchToProps = dispatch => ({
  getActivityExcel: (start_date,end_date,student_id) =>
    dispatch(ActivityActions.activityExcelRequest(start_date,end_date,student_id)),
  editcheckout: (checkout_id,checkout_time) =>
    dispatch(ActivityActions.editCheckoutRequest(checkout_id,checkout_time)),
})

export default connect(mapStateToProps, mapDispatchToProps)(RecentActivity)



// WEBPACK FOOTER //
// ./src/Components/ProfileViews/RecentActivity.jsx